/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Pop_Up_TitleInputs */

const en_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited-time Bundle Offer Unlocked!`)
};

const ar_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فتح عرض الحزمة لفترة محدودة!`)
};

const de_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitlich begrenztes Paketangebot freigeschaltet!`)
};

const es_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Oferta de paquete por tiempo limitado desbloqueada!`)
};

const fr_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre de pack à durée limitée débloquée !`)
};

const it_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta del pacchetto a tempo limitato sbloccata!`)
};

const ja_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期間限定パックのオファーが解放されました！`)
};

const ko_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기간 한정 패키지 혜택이 열렸어요!`)
};

const pt_br_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta de pacote por tempo limitado desbloqueada!`)
};

const ru_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Специальное предложение на набор доступно на ограниченное время!`)
};

const th_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกข้อเสนอแพ็กเกจจำกัดเวลาแล้ว!`)
};

const tr_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırlı süreli paket teklifi açıldı!`)
};

const zh_cn_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限时礼包优惠已解锁！`)
};

const zh_tw_starter_pack_pop_up_title = /** @type {(inputs: Starter_Pack_Pop_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限時禮包優惠已解鎖！`)
};

/**
* | output |
* | --- |
* | "Limited-time Bundle Offer Unlocked!" |
*
* @param {Starter_Pack_Pop_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_pop_up_title = /** @type {((inputs?: Starter_Pack_Pop_Up_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Pop_Up_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_pop_up_title(inputs)
	if (locale === "ar") return ar_starter_pack_pop_up_title(inputs)
	if (locale === "de") return de_starter_pack_pop_up_title(inputs)
	if (locale === "es") return es_starter_pack_pop_up_title(inputs)
	if (locale === "fr") return fr_starter_pack_pop_up_title(inputs)
	if (locale === "it") return it_starter_pack_pop_up_title(inputs)
	if (locale === "ja") return ja_starter_pack_pop_up_title(inputs)
	if (locale === "ko") return ko_starter_pack_pop_up_title(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_pop_up_title(inputs)
	if (locale === "ru") return ru_starter_pack_pop_up_title(inputs)
	if (locale === "th") return th_starter_pack_pop_up_title(inputs)
	if (locale === "tr") return tr_starter_pack_pop_up_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_pop_up_title(inputs)
	return zh_tw_starter_pack_pop_up_title(inputs)
});